"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Form_1 = require("../Form");
var Modal_1 = require("./Modal");
var MESSAGE_STYLES = "text-md px-2 mb-4";
var Dialog = function (_a) {
    var children = _a.children, message = _a.message, cancelLabel = _a.cancelLabel, confirmLabel = _a.confirmLabel, handleConfirm = _a.onConfirm, handleCancel = _a.onCancel, modalProps = __rest(_a, ["children", "message", "cancelLabel", "confirmLabel", "onConfirm", "onCancel"]);
    return ((0, jsx_runtime_1.jsxs)(Modal_1.Modal, __assign({}, modalProps, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: MESSAGE_STYLES }, { children: message }), void 0), (0, jsx_runtime_1.jsxs)(Form_1.ButtonGroup, __assign({ direction: "row", grow: true }, { children: [handleCancel ? ((0, jsx_runtime_1.jsx)(Form_1.Button, __assign({ appearance: "secondary", className: "w-full flex-grow", onClick: handleCancel }, { children: cancelLabel !== null && cancelLabel !== void 0 ? cancelLabel : "Cancel" }), void 0)) : null, (0, jsx_runtime_1.jsx)(Form_1.Button, __assign({ appearance: "primary", className: "w-full flex-grow", onClick: handleConfirm }, { children: confirmLabel !== null && confirmLabel !== void 0 ? confirmLabel : "Confirm" }), void 0)] }), void 0)] }), void 0));
};
exports.Dialog = Dialog;
